// 本地数据库配置

export default {
	db_name:'yswl_chat_im',
	db_version:'1.0',
	db_desc:'yswl chat system databases',
	db_size:200*1024*1024,
	
	// 返回数据库连接
	connect(){
		if(window.chatSqlConnent === undefined){
			window.chatSqlConnent = openDatabase(this.db_name,this.db_version,this.db_desc,this.db_size)
		}
		return window.chatSqlConnent
	}
}